import { createMergeReducer } from '../utils/reducer'

type Features = 'useMFA' | 'useFaq' | 'useContactUs' | 'usePlayer' | 'isElcano' |
  'useEpisodeListSortingT1' | 'useEpisodeListSortingT2' | 'useNodeGiftCard' | 'useNewHover'

export type FeatureToStatus = { [feature in Features]?: boolean }
export const reducer = createMergeReducer(
  t => t.features,
  {} as FeatureToStatus
)
